import { useEffect, useState } from "react";
import { getConsent, setConsent } from "@/lib/analytics";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (!c) {
      // small delay to let hero render first
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const handle = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Preferenze cookie"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[60] fade-up"
    >
      <div className="relative bg-white border border-gray-100 rounded-2xl shadow-[0_16px_50px_rgba(11,74,90,0.16)] p-6">
        <button
          type="button"
          data-testid="cookie-close"
          aria-label="Chiudi"
          onClick={() => handle("denied")}
          className="absolute top-3 right-3 text-gray-400 hover:text-[#0B4A5A] transition"
        >
          <X size={16} />
        </button>
        <p className="overline">Privacy</p>
        <h3 className="font-serif text-lg text-[#0B4A5A] mt-2 leading-tight">
          Rispettiamo la tua privacy
        </h3>
        <p className="mt-2 text-sm text-gray-600 leading-relaxed">
          Utilizziamo cookie analitici anonimi (Google Analytics) per migliorare
          il sito. Non condividiamo dati con terze parti a scopo pubblicitario.{" "}
          <a
            href="/privacy"
            className="text-[#0B4A5A] font-medium link-underline"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <button
            type="button"
            data-testid="cookie-accept"
            onClick={() => handle("granted")}
            className="flex-1 bg-[#0B4A5A] text-white px-4 py-2.5 rounded-full text-sm font-medium hover:bg-[#0D5E73] transition-colors"
          >
            Accetta
          </button>
          <button
            type="button"
            data-testid="cookie-reject"
            onClick={() => handle("denied")}
            className="flex-1 border border-gray-200 text-gray-700 px-4 py-2.5 rounded-full text-sm font-medium hover:border-[#0B4A5A] hover:text-[#0B4A5A] transition-colors"
          >
            Rifiuta
          </button>
        </div>
      </div>
    </div>
  );
}
